export default "__VITE_ASSET__Cn705IZq__"